import { _Application, CurrentApplication } from '@organization/api/requests'
import { useApplicationIcon } from '@organization/hooks'
import { applicationTypes } from '@organization/layout/Applications'
import { useStyles } from '@organization/layout/Applications/Views/ListView/styles'
import { Flex, Typography } from 'antd'
import classNames from 'classnames'
import { TickCircle } from 'iconsax-react'

type Props = {
  currentApplication?: CurrentApplication
  application: _Application
}

/**
 *
 * @param currentApplication - The current application
 * @param application - The application to display
 * @description This component is used to display the application in a list view.
 * @example
 * ```tsx
 * <ListView currentApplication={currentApplication} application={application} />
 * ```
 */

export const ListView = ({ currentApplication, application }: Props) => {
  const isSelected = currentApplication?.token === application?.token

  const appType = application?.instance_type?.type ?? ''
  const applicationIcon = useApplicationIcon(appType)

  const { styles } = useStyles({ isSelected, applicationIcon })

  const { icon: AppIcon } =
    applicationTypes[appType] ?? applicationTypes.default

  const onClick = () => {
    window.location.replace(`/apps/${appType}/${application.token}`)
  }

  return (
    <Flex className={styles.item} onClick={onClick}>
      <Flex gap={16} align="center" className={styles.fullWidth}>
        <Flex
          align="center"
          className={classNames(styles.icon, styles.applicationIcon)}
        >
          <AppIcon />
        </Flex>
        <Flex vertical justify="space-between">
          <Typography.Text strong className={styles.text} id="title">
            {application?.instance_type?.name}
          </Typography.Text>

          <Typography.Text type="secondary">
            {application?.instance_type?.description}
          </Typography.Text>
        </Flex>
      </Flex>
      {isSelected && <TickCircle size={24} className={styles.text} />}
    </Flex>
  )
}
